// src/theme/components/skeleton.js
// GitHub / Linear stili yumusak shimmer. Semantic token tabanli.

const Skeleton = {
  baseStyle: {
    borderRadius: 'md',
    startColor: 'bgSecondary',
    endColor: 'bgTertiary',
  },
  defaultProps: {
    speed: 1.2,
    fadeDuration: 0.4,
  },
};

export default Skeleton;
